<!-- 通用订单页 -->
<template>
  <div class="orderlist">
    <template v-if="list.length > 0">
      <div class="listbox">
        <div class="order" v-for="order in list" :key="order.sn">
          <div class="order-header">
            <div class="order-id">订单编号：{{order.sn}}</div>
            <div class="order-date">订单日期：{{order.time}}</div>
            <div class="order-state">已完成</div>
          </div>
          <div class="order-detail">
            <img class="order-icon" :src="order.icon" :onerror="defaultIconUrl">
            <div class="order-info">
              <div class="order-title">{{order.name}}</div>
              <div class="order-price">￥{{order.priceLabel}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="more-tip" v-if="list.length >= 30">更多订单请下载口袋故事app查看</div>
      <div class="more-tip" v-if="list.length < 30">所有订单已加载完毕</div>
    </template>
    <template v-else>
      <empty-list class="emptylist" />
    </template>
  </div>
</template>

<script>
import EmptyList from '@/components/EmptyList/index'
import { getOrderList } from '@/api/order'

export default {
  components: { EmptyList },
  data () {
    return {
      list: [],
      defaultIconUrl: 'this.src="' + require('../../assets/global/error.jpg') + '"',
    }
  },
  computed: {

  },
  created() {
    this.getOrderList()
  },
  mounted() {

  },
  methods: {
    async getOrderList() {
      let orderList
      this.$daidiLoading.show({
        text: '数据加载中，请稍候...',
      })
      try {
        orderList = await getOrderList(this.$store.getters.token)
        this.$daidiLoading.hide()
      } catch (err) {
        this.$daidiLoading.hide()
        return
      }
      if (orderList.order_list) {
        let list = []
        orderList.order_list.forEach(order => {
          list.push({
            sn: order.order_sn,
            time: order.create_ts,
            name: order.good_name,
            icon: order.good_type === 'vip' ? require('../../assets/order/order-icon.png') : order.good_icon,
            type: order.good_type,
            priceLabel: order.order_price_label,
          })
        })
        this.list = list
      }
    }
  },
}
</script>

<style scoped lang="less">
  .orderlist {
    padding-bottom: .48rem;
    min-height: 100vh;
    background: #f4f4f8;
  }
  .listbox {
    .order {
      position: relative;
      padding: 0 .32rem;
      margin-bottom: .24rem;
      background: #fff;
    }
    .order-header {
      position: relative;
      padding: .24rem 0;
      border-bottom: 1px solid rgba(0,0,0,.1);
      .order-id, .order-date {
        font-size: .24rem;
        color: #c4c4c6;
      }
      .order-state {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: .28rem;
        // color: #fe7058;
        color: #C4C4C6;
        font-weight: bold;
      }
    }
    .order-detail {
      display: flex;
      padding: .3rem 0 .4rem 0;
    }
    .order-icon {
      width: 1.6rem;
      height: 1.6rem;
      border-radius: .12rem;
    }
    .order-info {
      flex: 1;
      margin-left: .24rem;
      .order-title {
        font-size: .32rem;
        color: #6c6c73;
        font-weight: bold;
      }
      .order-price {
        margin-top: .08rem;
        font-size: .32rem;
        color: #fe7058;
        font-weight: bold;
      }
    }
  }
  .more-tip {
    font-size: .28rem;
    color: #c4c4c6;
    text-align: center;
    padding: .28rem .48rem 0 .48rem;
  }
</style>
